import React from "react";
import { Link2 } from "react-feather";
import { Feed } from "../../types/api/Feed";
import { PostsForFeed } from "../../types/api/PostsForFeeds";
import { PLATFORM_LINK_CONFIG } from "./socialPlatforms";

export interface ViewPostLinkProps {
  feed: Feed;
  postForFeed: PostsForFeed;
}

export function ViewPostLink({ feed, postForFeed }: ViewPostLinkProps) {
  if (!postForFeed.live_post_id || !feed.slug) {
    return null;
  }

  const config = PLATFORM_LINK_CONFIG[feed.slug];
  if (!config) {
    return null;
  }

  return (
    <div className="mt-2">
      <a
        className="btn btn-ghost btn-sm w-full"
        href={config.getUrl(postForFeed.live_post_id)}
        target="_blank"
        rel="noopener noreferrer"
      >
        <Link2 size={16} /> {config.label}
      </a>
    </div>
  );
}
